const scrollToElement = (element) => {
  let target = document.querySelector(element);
  let targetOffset = target.getBoundingClientRect().top;
  let headerHeight = document
    .querySelector("header")
    .getBoundingClientRect().height;
  let scrollEl = targetOffset + window.scrollY - headerHeight - 10;

  $("html, body").stop().animate({ scrollTop: scrollEl }, 400);
};

export const init = () => {
  let attempts = 0;
  const whenComplete = () => {
    let donationForm = document.querySelector("#donation_form");

    if (++attempts > 30) return;
    if (donationForm) {
      let nextBtns = donationForm.querySelectorAll(".donation-form__btn-next");

      nextBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          if (window.innerWidth <= 992) {
            e.preventDefault();
            setTimeout(() => scrollToElement(btn.getAttribute("href")), 100);
          }
        });
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
